// extracted by mini-css-extract-plugin
module.exports = {"example_responsive_1":"googleAd_example_responsive_1__JD9tO","example_responsive_top":"googleAd_example_responsive_top__fsDev"};